import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { cn } from "@/lib/utils";

export function TalkToUs() {
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div
        className={cn(
          "flex items-center gap-3 rounded-sm px-3 py-2 text-sm font-medium transition-all duration-200 hover-lift",
          "text-muted-foreground hover:bg-stone-50/80 hover:text-accent-foreground cursor-pointer"
        )}
        onClick={() => setShowDialog(true)}
      >
        <FontAwesomeIcon icon={faComments} className="w-5 h-5 mr-2" />
        <span>Talk to Us</span>
      </div>

      <Dialog open={showDialog} onOpenChange={setShowDialog}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle className="text-xl">Need a hand? Let's chat. 👋</DialogTitle>
            <DialogDescription className="text-base">
              Whether you have a question, feedback, or just want to brainstorm how Creator can fit into your content strategy — we're here for you.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-2">
            <ul className="list-disc pl-5 space-y-2">
              <li>Curious about which plan is right for you?</li>
              <li>Want help setting up your first project?</li>
              <li>Have ideas or feedback to make Creator even better?</li>
            </ul>
            
            <p className="font-medium">We'd love to hear from you.</p>
            
            <div className="flex flex-col space-y-3 pt-2">
              <Button 
                variant="default" 
                onClick={() => window.open("https://cal.com/aicreator/30min", "_blank")}
                className="w-full"
              >
                👉 Book a quick call
              </Button>
              <Button 
                variant="outline" 
                onClick={() => window.open("https://wa.link/lq2li9", "_blank")}
                className="w-full"
              >
                👉 Message us on WhatsApp
              </Button>
            </div>
            
            <p className="text-sm text-muted-foreground italic text-center pt-2">
              No bots. No waiting. Just real conversations with real people who actually care.
            </p>
          </div>
          <DialogFooter className="sm:justify-center">
            <Button 
              variant="ghost" 
              onClick={() => setShowDialog(false)}
            >
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
